import { useMemo } from "react";
import { JText } from "../Text/Text";

type Props = {
  option: {
    value: string | boolean | number;
    label: string;
  };
  value?: string | string[] | boolean | number | undefined;
  onChange?: (value: string | string[] | boolean | number | undefined) => void;
  className?: string;
  disabled?: boolean;
  editable?: boolean;
};

export function SelectableOptionButton({
  option,
  value,
  onChange = () => {},
  className: classname = "",
  disabled = false,
  editable = true,
}: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onOptionPressed = () => {
    if (
      typeof value === "string" ||
      typeof value === "boolean" ||
      typeof value === "number" ||
      value === null
    ) {
      onChange(option.value);
    } else if (Array.isArray(value)) {
      if (value?.length === 0) {
        onChange([option.value as string]);
      } else if (value?.includes(option.value as string)) {
        onChange(value?.filter((item) => item !== option.value));
      } else {
        const newTab: string[] = [...value, option.value as string];
        onChange(newTab);
      }
    } else {
      onChange(option.value);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isSelected = useMemo(() => {
    if (
      typeof value === "string" ||
      typeof value === "boolean" ||
      typeof value === "number"
    ) {
      return value === option.value;
    }

    return value?.includes(option.value as string);
  }, [value, option.value]);

  return (
    <div
      className={`flex h-[44px] min-w-[100px] max-w-[100px] items-center justify-center rounded-lg px-2 flex-1 transition-all duration-300 ${
        isSelected
          ? "bg-primary text-white cursor-default"
          : "bg-slate-200 text-primary cursor-pointer"
      } ${classname} ${disabled || !editable ? "disabled" : ""}`}
      onClick={disabled || !editable ? undefined : onOptionPressed}
    >
      <JText
        label={
          option.label ||
          (typeof option.value === "number"
            ? (option.value as unknown as string)
            : option.value)
        }
        colorName="blueHigh"
        isBold
      />
    </div>
  );
}

export default SelectableOptionButton;
